interface QuizInternalBackHistoryAnswerOption {
  answerOptionId: string;
  value: string;
}

interface QuizInternalBackHistoryItem {
  currentquestion: number;
  answer: QuizInternalBackHistoryAnswerOption[];
}

interface QuizInternalAnswerOption {
  id: string;
  answerValue: string | null;
  answerText: string | null;
}

interface QuizInternalQuestion {
  identifier: string;
  identifierEnabled: boolean;
  title: string;
  description: string;
  questionType: "_tagInput" | "_multiDropdown" | "_singleChoice" | "_multiChoice";
  answerOptions: QuizInternalAnswerOption[];
  content: string;
  // ... skipping parts that we arent using
}

interface QuizInternalQuiz {
  uniqueIdentifier: string;
  questions: QuizInternalQuestion[];
  title: string;
  id: number;
  version: number;
  metadata: any;
  // ... skipping parts that we arent using
}

export interface QuizInternalData {
  // captured answers only as questionIdentifier: answerText
  answers: Record<string, string>;
  // all answered questions and their answers
  backHistory: QuizInternalBackHistoryItem[];
  currentQuestion: number;
  interstitialHistory: any[];
  points: number[];
  quiz: QuizInternalQuiz;
  status: string | "inProgress";
  uid: string;
  result: any;
}

export interface QuizAnswerExtended {
  questionIdentifier: string;
  questionTitle: string;
  questionDescription?: string;
  questionType: string;
  answerText: string;
}

/**
 * copied from qubl function that prepares output for captured variables
 */
export function getAnswer(questionInfo: QuizInternalQuestion, answer: QuizInternalBackHistoryAnswerOption[]) {
  return ["_multiChoice", "_singleChoice"].includes(questionInfo.questionType)
    ? answer
      .map((ans: QuizInternalBackHistoryAnswerOption) => {
        const option =
          questionInfo.answerOptions.find((ansOption: QuizInternalAnswerOption) => ansOption.id === ans.answerOptionId) ||
          <QuizInternalAnswerOption>{};
        return option.answerValue || option.answerText;
      })
      .join(",")
    : ["_tagInput", "_multiDropdown"].includes(questionInfo.questionType)
      ? answer
        .map((ans: QuizInternalBackHistoryAnswerOption) => {
          try {
            return JSON.parse(ans.value).join(",");
          } catch (_) {
            return "";
          }
        })
        .join(",")
      : answer.map((ans: QuizInternalBackHistoryAnswerOption) => ans.value).join(",");
}


interface GetAllAnswersOptions {
  onlyCaptured?: boolean;
  collapseDuplicateIdentifiers?: boolean;
}

export function getQuizTitle(quizData: QuizInternalData): string {
  return quizData.quiz.title;
}

/**
 * Returns all captured answers for a quiz, including the question text.
 */
export function getAllAnswersExtended(quizData: QuizInternalData, options?: GetAllAnswersOptions): QuizAnswerExtended[] {
  const parsedOptions = {
    onlyCaptured: options?.onlyCaptured ?? true,
    collapseDuplicateIdentifiers: options?.collapseDuplicateIdentifiers ?? true,
  }

  const answers: QuizAnswerExtended[] = [];

  const { quiz, backHistory } = quizData;

  backHistory.forEach((item: QuizInternalBackHistoryItem) => {
    const question = quiz.questions[item.currentquestion];
    if (!question) return;
    if (parsedOptions.onlyCaptured && !question.identifierEnabled) return;

    if (parsedOptions.collapseDuplicateIdentifiers) {
      // Check if the question identifier already exists in the answers array
      const existingAnswerIndex = answers.findIndex(answer => answer.questionIdentifier === question.identifier);
      if (existingAnswerIndex > -1) {
        answers.splice(existingAnswerIndex, 1);
      }
    }

    answers.push({
      questionIdentifier: question.identifier,
      questionTitle: question.title,
      //questionDescription: question.description,
      questionType: question.questionType,
      answerText: getAnswer(question, item.answer),
    });
  });

  return answers;
}